import http from "@/helper/http";
import {useMutation, useQuery} from "@tanstack/react-query";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {ContactPO} from "@/model/customer";
import {WriteContactForm} from "@/pages/Contact/WriteContact";
import {PatentPO} from "@/model/product";
import {PatentEnum, SearchPatentBO} from "@/service/patent.s";

export enum ContactEnum {
    GetContactPage = "/contact/getContactPage",
    CreateContact = "/contact/createContact",
    UpdateContact = "/contact/updateContact",
    GetContact = "/contact/getContact",
    SearchContact = "/contact/searchContact",
}

export interface ContactPageVO extends ContactPO {

}

export interface ContactVO extends ContactPO {
    customerName: string;
}

export interface SearchContactBO {
    keyword: string;
}

export interface SearchContactVO {
    id: number
    name: string
}

export const useCreateContact = () => useMutation<BaseVO<null>, null, WriteContactForm>({
    mutationFn: (data: WriteContactForm) =>
        http.put<BaseVO<null>>({url: ContactEnum.CreateContact, data})
})

export const useUpdateContact = () => useMutation<BaseVO<null>, null, WriteContactForm>({
    mutationFn: (data: WriteContactForm) =>
        http.post<BaseVO<null>>({url: ContactEnum.UpdateContact, data})
})

export const useQueryContactPage = () => useMutation({
    mutationFn: (data: ContactPageVO) => http.post<BaseVO<PaginationVO<ContactPageVO>>>({
        url: ContactEnum.GetContactPage,
        data: data,
    }),
})

export const useQueryContact = (params: GetByIdBO, enabled = true) => useQuery({
    queryKey: [params.id],
    queryFn: () => http.get<BaseVO<ContactVO>>({url: ContactEnum.GetContact, params}),
    enabled
});

export const useSearchContact = () => useMutation({
    mutationFn: (data: SearchContactBO) => http.post<BaseVO<SearchContactVO[]>>({
        url: ContactEnum.SearchContact,
        data
    }),
})


